// AUTO-GENERATED — split out of explainer-catalog.ts on 2026-05-19 to
// keep each per-type data module under G03's 1200-LOC data ceiling.
// Re-generate the parent + all shards together; do not hand-edit shards.

import type { ExplainerCatalogEntry } from "./explainer-catalog-types";

export const EXPLAINER_CATALOG_DOSHA: ExplainerCatalogEntry[] = [
  {
    id: "mangal_dosh",
    type: "dosha",
    display_name: "Mangal Dosh",
    display_name_hi: "मंगल दोष",
    what_it_means:
      'Mangal Dosh appears in your kundali when Mars (Mangal) sits in the\n1st, 2nd, 4th, 7th, 8th, or 12th house. In classical Vedic Jyotish,\nthese are the houses that govern your marriage, family, partnerships,\nand longevity in relationships. Mars is a fiery, assertive planet —\nwhen it lands in one of these "soft" houses, its raw energy can\ncreate friction, delays, or unexpected turbulence around the time\nof marriage or within married life.\n\nThis is not a curse and not a verdict. It is a pattern your chart\ncarries — a karmic signature that asks you to handle relationships\nwith deliberate care, patience, and the right upays. Many of the\nmost successful marriages in India happen with one or both partners\ncarrying Mangal Dosh; the dosha responds to remedy.\n',
    intensity_buckets: {
      low: {
        label: "Mild",
        prose:
          "A mild Mangal Dosh means Mars influences only one or two of the\nrelevant houses, or is calmed by a benefic aspect from Jupiter\nor the Moon. The pattern is present but soft — small everyday\nfrictions, occasional sharpness in temperament, but no major\nstructural issues in marriage. Standard upays are usually\nenough; a deeper consultation is optional.\n",
      },
      medium: {
        label: "Moderate",
        prose:
          "A moderate Mangal Dosh means Mars sits in a marriage-related\nhouse with meaningful strength and no full cancellation from\nbenefic aspects. You may notice repeating patterns: delays in\nfinding a partner, recurring conflicts around the same themes,\nor a temperament that flares unexpectedly. Structured upays\ndone consistently over months produce real change here.\n",
      },
      high: {
        label: "Strong",
        prose:
          "A strong Mangal Dosh reflects Mars in the most sensitive\nmarriage houses (7th, 8th, or 12th), often debilitated or\nconjunct other malefics. This is the placement that classical\ntexts treat most seriously. Partner selection matters — many\nJyotishis advise matching with another Mangalik to neutralise\nthe effect. Upays alone help, but a personalised reading from\nan experienced Jyotishi is strongly recommended.\n",
      },
    },
    upays: [
      {
        title: "Recite Hanuman Chalisa every Tuesday",
        why: "Hanuman is the deity who pacifies Mars's fierce energy. Tuesday is Mars's day — the recitation aligns the remedy with the planet's vibration.",
        title_hi: "Har Mangalvaar Hanuman Chalisa ka paath karein",
        why_hi:
          "Hanuman ji Mangal ki ugra urja ko shaant karte hain. Mangalvaar Mangal ka din hai — paath upay ko graha se jodta hai.",
        how: "Recite 7 times before sunrise every Tuesday. Light a chameli or red sandalwood incense. Continue for at least 40 days without break.",
      },
      {
        title: "Wear Red Coral (Moonga) on the right ring finger",
        why: "Coral is the gemstone of Mars. Wearing it constructively channels Mars's energy instead of letting it scatter.",
        how: "Consult a Jyotishi for muhurat (auspicious time) and stone weight before purchase. Energise with Mars mantras before first wear.",
      },
      {
        title: "Donate red lentils (masoor dal) every Tuesday",
        why: "Mars governs the colour red and the lentil family. Donating these reduces the planet's harsh imprint on your chart.",
        how: "Give 1 kg of red masoor dal to a temple or person in need every Tuesday for 11 weeks.",
      },
    ],
    cta: {
      product: "marriage_reading",
      label: "Get full Marriage Compatibility Reading",
      price_inr: 149,
      deep_link: "ishvaram://reports/marriage",
    },
  },
  {
    id: "kaal_sarp_dosh",
    type: "dosha",
    display_name: "Kaal Sarp Dosh",
    display_name_hi: "काल सर्प दोष",
    what_it_means:
      'Kaal Sarp Dosh forms when all seven traditional planets in your\nkundali sit between Rahu and Ketu — the two karmic shadow points\nof the chart. In Vedic Jyotish, Rahu represents unprocessed\ndesire and Ketu represents karmic residue. When every planet is\ncaught between them, it creates a "snake" of karmic influence\nthat surrounds your entire chart.\n\nThe effect is rarely dramatic in a single area — it shows up as\na sense of effort never quite matching reward, dreams that\ninclude snakes or chasing, sudden ups and downs in career or\nrelationships, and a feeling that something invisible is holding\nyou back even when you can\'t name it. Classical texts treat Kaal\nSarp seriously, but every major Jyotishi has seen this dosha\nyield to consistent upay and chart-aware remedies.\n',
    intensity_buckets: {
      low: {
        label: "Partial",
        prose:
          'A partial Kaal Sarp Dosh means most planets sit between Rahu\nand Ketu but one or two slip outside. The pattern is present\nbut the planets that escape provide their own buffer of\nstability. You may notice the "two steps forward, one step\nback" rhythm in specific life areas tied to the escaped\nplanets. Basic upays are usually sufficient.\n',
      },
      medium: {
        label: "Strong",
        prose:
          "A strong Kaal Sarp Dosh means all seven planets are caught\non one side of the Rahu-Ketu axis. The karmic loop is\ncomplete and tends to show up in patterns: unexpected losses\nright before a breakthrough, hard work that doesn't convert\nto results in the usual way, or repeating cycles in\nrelationships. Sustained upay over 90+ days and a Jyotishi-\nguided puja produce measurable shifts.\n",
      },
      high: {
        label: "Severe",
        prose:
          "A severe Kaal Sarp Dosh combines the full planetary alignment\nwith additional weakness in the chart — a debilitated Moon,\nafflicted lagna, or simultaneous mahadasha of Rahu or Ketu.\nThis is the configuration where personalised remedy makes the\nbiggest difference. Standard upays help, but a chart-specific\nreading and a guided Kaal Sarp Shanti puja (often at\nTrimbakeshwar or Kalahasti) are the classical responses.\n",
      },
    },
    upays: [
      {
        title: "Worship Lord Shiva on Mondays",
        why: "Shiva is the deity who tames the snakes around his neck — symbolically, he is the master of Rahu-Ketu energy.",
        title_hi: "Har Somvaar Bhagwan Shiv ki puja karein",
        why_hi:
          "Shiv ji Rahu-Ketu ki sarp urja ke swami hain — unki puja is poori chain ko shaant karti hai.",
        how: "Offer water on a Shivling every Monday morning. Recite Mahamrityunjaya Mantra 108 times. Maintain for at least 11 weeks.",
      },
      {
        title: "Donate to snake conservation or feed brahmins",
        why: "Kaal Sarp is the karmic debt of past harm to serpents or ancestors. Reparative donation lightens the karmic load.",
        how: "Donate to a snake park, contribute to nag panchami rituals, or arrange brahmin bhoj on Saturdays.",
      },
      {
        title: "Visit Trimbakeshwar or Kalahasti for Kaal Sarp Shanti",
        why: "These two temples are classical sites where the puja for Kaal Sarp is performed with full procedure.",
        how: "Plan a visit on an amavasya (new moon). Book the puja in advance through the temple trust. Combine with chart consultation.",
      },
    ],
    cta: {
      product: "brihat_reading",
      label: "Get full Brihat Kundali Reading",
      price_inr: 199,
      deep_link: "ishvaram://reports/brihat",
    },
  },
  {
    id: "pitra_dosh",
    type: "dosha",
    display_name: "Pitra Dosh",
    display_name_hi: "पितृ दोष",
    what_it_means:
      "Pitra Dosha arises when the Sun forms challenging aspects with Rahu, Ketu, or Saturn, or occupies the 9th house with malefic influences. This reflects unresolved ancestral obligations manifesting as disruptions in family harmony, inherited challenges, or financial instability. The dosha suggests past generations' unfulfilled duties requiring reconciliation through ritual and devotion. Over time, unaddressed cases may deepen ancestral discontent, affecting descendants' prosperity and relationships.\n",
    intensity_buckets: {
      low: {
        label: "Mild",
        prose:
          "Minor family disagreements or delayed financial gains may surface. Ancestral whispers remain subtle, requiring attention to subtle patterns in career or child matters. Occasional obstacles in property or father figures' health hint at pending resolutions.\n",
      },
      medium: {
        label: "Moderate",
        prose:
          "Persistent conflicts between generations or unexplained setbacks in wealth creation. Father-son dynamics may strain, with health issues recurring in paternal lineage. Ancestral expectations become palpable through recurring disputes over inheritance or career stagnation.\n",
      },
      high: {
        label: "Strong",
        prose:
          "Severe disruptions in family unity, with legal battles over assets. Father's health suffers significantly, and children face unexplained adversities. Generational curses manifest as chronic poverty or broken familial bonds, demanding urgent ritual intervention.\n",
      },
    },
    upays: [
      {
        title: "Wear a Rudraksha Bracelet",
        why: "Rudraksha channels ancestral blessings through Lord Shiva's grace.",
        title_hi: "Rudraksha bracelet pehnein",
        why_hi: "Rudraksha Shiv ji ki kripa se purvajon ka ashirwad aap tak pahunchata hai.",
        how: "Wear 108-ruled rudraksha (preferably Prayag or Dhar variety) on the right hand's middle finger.",
      },
      {
        title: "Perform Pitru Tarpan",
        why: "Pitru Paksha rituals bridge communication with forefathers.",
        how: "Offer black sesame water with barley during sunrise, chanting Vedas and father's name.",
      },
      {
        title: "Install an Energized Ganesha Idol",
        why: "Removes ancestral obstacles blocking progress.",
        how: "Place a panchmukhi Ganesha idol in northeast, adorned with red cloth and durva grass.",
      },
    ],
    cta: {
      product: "brihat_reading",
      label: "Get full Brihat Kundali Reading",
      price_inr: 199,
      deep_link: "ishvaram://reports/brihat",
    },
  },
  {
    id: "shani_dosh",
    type: "dosha",
    display_name: "Shani Dosh",
    display_name_hi: "शनि दोष",
    what_it_means:
      "Shani Dosh occurs when Saturn (Shani) occupies or aspects critical houses in a kundali, particularly the 1st, 4th, 7th, 8th, or 10th. This configuration often brings prolonged delays, unexpected obstacles, and karmic lessons that require patience. The severity varies depending on the affected house – Saturn’s influence on marital life (7th), longevity (8th), or career (10th) often manifests as life’s most persistent challenges. Culturally, Shani represents discipline and karma, making this dosha a period for spiritual growth through adversity.\n",
    intensity_buckets: {
      low: {
        label: "Mild",
        prose:
          "Subtle delays in personal or professional growth may appear, often resolved through minor adjustments. Relationships might feel temporarily strained but remain functional. Financial or health matters could require steady effort rather than drastic measures. This phase serves as a gentle reminder to align actions with dharma.\n",
      },
      medium: {
        label: "Moderate",
        prose:
          "Noticeable disruptions in career stability, marriage harmony, or health routines emerge. Financial plans face unexpected hurdles, and family responsibilities demand greater attention. Social standing may feel temporarily affected. This intensity pushes individuals toward deeper self-reflection and corrective actions.\n",
      },
      high: {
        label: "Strong",
        prose:
          "Life events stall dramatically – career stagnation, prolonged illnesses, or marital discord become prominent. Financial losses or legal complications often accompany this phase. Social isolation or reputation challenges may test one’s resilience. The universe demands complete surrender to karmic lessons, often reshaping life’s direction.\n",
      },
    },
    upays: [
      {
        title: "Use karungali wood",
        why: "Karungali (ebony) is Shani’s sacred material, neutralizing his harsh influence.",
        title_hi: "Karungali (ebony) wood istemaal karein",
        why_hi:
          "Karungali Shani ka pavitra material hai — Shani ka kathor prabhav shaant hota hai.",
        how: "Place it in your home or wear as a bracelet during Shani’s hours (Saturday mornings).",
      },
      {
        title: "Recite Shani Stotram",
        why: "Devotional chanting appeases Saturn’s cosmic justice system.",
        how: "Jap Shani Stotram on Saturdays while donating black sesame or iron items.",
      },
      {
        title: "Wear iron ring",
        why: "Saturn governs iron – this strengthens his aspect on the middle finger.",
        how: "A plain iron ring worn on the middle finger during daybreak daily for 40 days.",
      },
    ],
    cta: {
      product: "brihat_reading",
      label: "Get full Brihat Kundali Reading",
      price_inr: 199,
      deep_link: "ishvaram://reports/brihat",
    },
  },
  {
    id: "rahu_dosh",
    type: "dosha",
    display_name: "Rahu Dosh",
    display_name_hi: "राहु दोष",
    what_it_means:
      "Rahu Dosha arises when Rahu occupies the 1st, 5th, 7th, 8th, or 12th houses in the kundali. This configuration creates a strong inclination toward obsessive desires, illusions, and unpredictable life events. It often manifests as restlessness in relationships, financial matters, or spiritual pursuits. The native may experience sudden upheavals or an unusual attraction to foreign influences. Over time, this dosha requires mindful upay to balance its disruptive energy.\n",
    intensity_buckets: {
      low: {
        label: "Mild",
        prose:
          "The native may feel occasional restlessness in career or marriage prospects. Small obsessions about status or foreign connections might surface. There could be minor confusion in decision-making during Rahu periods. Periodic feelings of detachment from traditional values may appear.\n",
      },
      medium: {
        label: "Moderate",
        prose:
          "Relationships or creative endeavors often face instability. Strong cravings for unconventional lifestyles or sudden foreign associations emerge. Financial decisions may swing between extremes. Mental clarity diminishes during Rahu transits, leading to impulsive actions.\n",
      },
      high: {
        label: "Strong",
        prose:
          "Life paths appear dominated by erratic events and obsessive fixations. Core relationships suffer from trust issues or unexplainable disruptions. Financial losses from risky ventures are likely. The native may struggle with identity crises and spiritual confusion. Traditional remedies become crucial for grounding.\n",
      },
    },
    upays: [
      {
        title: "Wear Rudraksha Mala",
        why: "Rudraksha's sacred energy counters Rahu's illusory influence",
        title_hi: "Rudraksha mala pehnein",
        why_hi: "Rudraksha ki pavitra urja Rahu ke bhram bhare prabhav ko shaant karti hai.",
        how: "Wear a 108-bead Rudraksha mala daily, preferably made of original Rudraksha seeds",
      },
      {
        title: "Install Hessonite Gem",
        why: "Hessonite (Gomed) pacifies Rahu's malefic effects",
        how: "Consult a qualified astrologer for proper activation and wearing procedure",
      },
      {
        title: "Recite Rahu Beej Mantra",
        why: "Chanting Rahu's seed mantra strengthens spiritual focus",
        how: "Jap the mantra 'Om Ra Rahave Namah' 108 times on Saturdays with black sesame offerings",
      },
    ],
    cta: {
      product: "brihat_reading",
      label: "Get full Brihat Kundali Reading",
      price_inr: 199,
      deep_link: "ishvaram://reports/brihat",
    },
  },
  {
    id: "ketu_dosh",
    type: "dosha",
    display_name: "Ketu Dosh",
    display_name_hi: "केतु दोष",
    what_it_means:
      "Ketu Dosh arises when Ketu occupies specific houses in the kundali, creating tendencies for sudden disruptions, spiritual detachment, and unresolved karmic patterns. This alignment often manifests as unexpected challenges in career, relationships, or self-identity, alongside a deep urge for liberation. The intensity varies based on Ketu's placement – some experience it as periodic turbulence, while others face persistent instability in key life areas. Over time, this dosha pushes individuals toward spiritual evolution, even through difficult circumstances.\n",
    intensity_buckets: {
      low: {
        label: "Mild",
        prose:
          "Subtle signs of detachment emerge periodically, like sudden disinterest in long-term commitments. Minor setbacks in career or health may occur, often resolving quickly. Spiritual curiosity might surface unexpectedly, but practical life remains largely stable. The individual may feel occasional restlessness without clear cause.\n",
      },
      medium: {
        label: "Moderate",
        prose:
          'Noticeable instability in professional or marital life, with relationships experiencing abrupt changes. Emotional detachment becomes more pronounced, creating challenges in maintaining bonds. Spiritual seeking intensifies, sometimes conflicting with worldly responsibilities. The individual may feel a persistent sense of "incomplete" experiences.\n',
      },
      high: {
        label: "Strong",
        prose:
          "Life events unfold unpredictably – sudden losses, broken promises, or radical shifts in identity. Deep existential questions arise, often paired with feelings of isolation. Material security feels elusive, while spiritual urgency dominates decision-making. The native might struggle to balance worldly duties with an overwhelming call for moksha.\n",
      },
    },
    upays: [
      {
        title: "Wear a Rudraksha Bracelet",
        why: "Rudraksha's spiritual energy counteracts Ketu's disruptive nature",
        title_hi: "Rudraksha bracelet pehnein",
        why_hi: "Rudraksha ki spiritual urja Ketu ke bikhrav ko shaant karti hai.",
        how: "Wear 108-ruled rudraksha beads on the right hand daily, particularly during Rahu Kaal",
      },
      {
        title: "Worship Lord Ganesha",
        why: "Removes obstacles and restores balance in karmic patterns",
        how: "Offer modaks and chant 'Om Gan Ganapataye Namaha' 108 times every Tuesday",
      },
      {
        title: "Incorporate Cat's Eye Gemstone",
        why: "Strengthens Ketu's spiritual lessons while grounding energy",
        how: "Wear a yellow sapphire (lehsunia) in the right hand's ring finger after sunrise",
      },
    ],
    cta: {
      product: "brihat_reading",
      label: "Get full Brihat Kundali Reading",
      price_inr: 199,
      deep_link: "ishvaram://reports/brihat",
    },
  },
  {
    id: "kemadruma_yoga",
    type: "dosha",
    display_name: "Kemadruma Dosh",
    display_name_hi: "केमद्रुम दोष",
    what_it_means:
      "Kemadruma Dosh arises when the Moon, ruler of mind and emotions, lacks conjunction or aspect from any planet in the 2nd or 12th houses from its rashi in a kundali. This configuration creates emotional distance from family and material challenges, as the Moon's nurturing energy remains un-supported. Classically linked to loneliness and financial instability, it reflects the Moon's inability to form meaningful connections or secure emotional anchors. Over time, this can manifest as social withdrawal or struggles in sustaining resources.\n",
    intensity_buckets: {
      low: {
        label: "Mild",
        prose:
          "Occasional feelings of emotional detachment surface during critical phases, but family ties remain functional. Minor material setbacks occur, resolved through small adjustments. The individual may experience brief periods of solitude but maintains practical resilience. Social circles provide temporary support during challenging times.\n",
      },
      medium: {
        label: "Moderate",
        prose:
          "Emotional isolation becomes noticeable, with relationships requiring conscious effort to sustain. Financial pressures intensify during key life transitions, demanding careful resource management. The native may feel unheard in family gatherings, leading to quiet resentment. A persistent sense of emotional hunger lingers beneath daily interactions.\n",
      },
      high: {
        label: "Strong",
        prose:
          "Prolonged emotional desolation creates a barrier to forming meaningful bonds, often leading to involuntary solitude. Material struggles escalate into systemic challenges, with income sources feeling perpetually unstable. The individual may internalize loneliness as personal failure, affecting self-worth. Traditional remedies become critical to restore balance in both emotional and physical realms.\n",
      },
    },
    upays: [
      {
        title: "Chant Hanuman Chalisa daily",
        why: "Hanuman's devotion to Rama soothes lunar distress and strengthens emotional anchors.",
        title_hi: "Roz Hanuman Chalisa ka paath karein",
        why_hi:
          "Hanuman ji ki Ram-bhakti Chandra ke bechain mann ko shaant karti hai aur emotional sahara deti hai.",
        how: "Recite 11 circuits during Brahma Muhurta, focusing on the Moon's rashi.",
      },
      {
        title: "Wear white coral (Mukta)",
        why: "This gem pacifies lunar afflictions and attracts nurturing energies.",
        how: "Wear on Monday mornings after sunrise, following proper activation rituals.",
      },
      {
        title: "Perform Tarpana with milk",
        why: "Honoring ancestors through lunar elements restores emotional continuity.",
        how: "Offer milk and barley to pitru daily during evening twilight hours.",
      },
    ],
    cta: {
      product: "brihat_reading",
      label: "Get full Brihat Kundali Reading",
      price_inr: 199,
      deep_link: "ishvaram://reports/brihat",
    },
  },
  {
    id: "guru_chandal_dosh",
    type: "dosha",
    display_name: "Guru Chandal Dosh",
    display_name_hi: "गुरु चांडाल दोष",
    what_it_means:
      "Guru Chandal Dosh arises when Jupiter (guru) conjuncts Rahu or Ketu in the kundali, creating a shadow on wisdom and ethical clarity. This alignment disrupts the natural beneficence of Jupiter, leading to distorted judgment, moral ambiguity, and impulsive decisions. It often manifests as confusion in spiritual or philosophical matters, strained relationships due to unethical choices, and a tendency to prioritize material gains over dharma. The dosha weakens one’s ability to discern truth from illusion, particularly in matters of career and family. Over time, unresolved cases may erode trust and invite karmic imbalances.\n",
    intensity_buckets: {
      low: {
        label: "Mild",
        prose:
          "Occasional lapses in discerning right from wrong, like misjudging a friend’s intentions. Minor ethical dilemmas arise, such as bending rules at work or family disputes over shared resources. The individual may feel conflicted but retains broad social acceptance. Remedies here restore balance without drastic measures.  \n",
      },
      medium: {
        label: "Moderate",
        prose:
          'Noticeable patterns of compromised integrity, like favoring personal gain over fairness. Relationships suffer due to broken promises or questionable alliances. The person may rationalize unethical acts as "necessary compromises." This intensity risks long-term reputational harm.  \n',
      },
      high: {
        label: "Strong",
        prose:
          "Deep-seated distortion of dharma, with decisions driven by selfishness or fear. Trust erodes completely, leading to isolation or legal troubles. The individual may openly defy societal norms, justifying harm to others. Such cases require intense spiritual rectification to prevent generational karma.  \n",
      },
    },
    upays: [
      {
        title: "Recite Hanuman Chalisa Daily",
        why: "Hanuman embodies righteousness and devotion to guru.",
        title_hi: "Roz Hanuman Chalisa ka paath karein",
        why_hi: "Hanuman ji dharm aur guru-bhakti ke pratik hain — paath sahi disha lautata hai.",
        how: "Chant the full text at sunrise, focusing on verses about wisdom and surrender.",
      },
      {
        title: "Donate Turmeric and Yellow Cloth",
        why: "Yellow symbolizes Jupiter’s wisdom; charity pacifies Rahu/Ketu’s corruption.",
        how: "Offer to temples or underprivileged students every Thursday for 40 days.",
      },
      {
        title: "Perform Guru Purnima Pujan",
        why: "Honoring Jupiter’s divine form neutralizes shadow influences.",
        how: "Ritually bathe a brass idol, chant the Guru Gayatri mantra 108 times, and feed yellow lentils to cows.",
      },
    ],
    cta: {
      product: "brihat_reading",
      label: "Get full Brihat Kundali Reading",
      price_inr: 199,
      deep_link: "ishvaram://reports/brihat",
    },
  },
];
